// extracted by mini-css-extract-plugin
module.exports = {"truncated":"BackgroundImageComponent_truncated__ktgbx","root":"BackgroundImageComponent_root__16e4f"};